import styles from "./Assets.module.scss";
import boostIcon from "./icons/boost.png";
import collectionIcon from "./icons/collection.png";
import ratingIcon from "./icons/rating.png";
import achievementIcon from "./icons/achievement.png";
import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock";
import { useContextNavigate } from "../../hooks/navigate";
import { AssetCard } from "../../components/AssetCard/AssetCard";
import { useEffect } from "react";
import { getAssets } from "../../redux/assets/get-assets.handler";
import { useDispatch, useSelector } from "../../hooks";
import { trueAchievementsForm, trueBoostsForm, trueCollectionsForm, trueRatingsForm } from "../../utils/true.word.form";
import { Loader } from "../../components/Loader/Loader";

export enum AssetsContext {
    Boosts = 'boosts',
    Collections = 'collections',
    Ratings = 'ratings',
    Achievements = 'achievements',
}

export interface ICardData {
    title: string;
    description: string;
    icon: string;
    colorClass: "blue" | "purple" | "orange" | "green";
    context?: AssetsContext;
}

const cardData: Map<AssetsContext, ICardData> = new Map([
    [
        AssetsContext.Boosts, {
            title: "Усиления",
            description: "",
            icon: boostIcon,
            colorClass: "blue",
            context: AssetsContext.Boosts,
        }
    ],
    [
        AssetsContext.Collections, {
            title: "Коллекции",
            description: "",
            icon: collectionIcon,
            colorClass: "purple",
            context: AssetsContext.Collections,
        }
    ],
    [
        AssetsContext.Ratings,
        {
            title: "Рейтинг",
            description: "",
            icon: ratingIcon,
            colorClass: "orange",
            context: AssetsContext.Ratings,
        }
    ],
    [
        AssetsContext.Achievements,
        {
            title: "Достижения",
            description: "",
            icon: achievementIcon,
            colorClass: "green",
            context: AssetsContext.Achievements,
        }
    ]
]);

export const AssetsTypes = () => {
    const navigate = useContextNavigate<AssetsContext>();
    const dispatch = useDispatch();
    const assets = useSelector(store => store.assets);

    useEffect(() => {
        dispatch(getAssets());
    }, [dispatch]);

    const getDescription = (context: AssetsContext) => {
        switch (context) {
            case AssetsContext.Ratings: return `${assets.ratings.length} ${trueRatingsForm(assets.ratings.length)}`;
            case AssetsContext.Collections: return `${assets.collectionsCount} ${trueCollectionsForm(assets.collectionsCount)}`;
            case AssetsContext.Boosts: return `${assets.boostsCount} ${trueBoostsForm(assets.boostsCount)}`;
            case AssetsContext.Achievements: return `${assets.achievementsCount} ${trueAchievementsForm(assets.achievementsCount)}`;
        }
    }

    return (
        <>
            <ContentWrapper>
                <div className={styles.wrapper}>
                    <PageTitleBlock pageTitle={"Активы"} />

                    <div className={styles.cardWrapper}>
                        { Array.from(cardData.values()).map((card, index) => (
                            <div
                                key={index}
                                onClick={ () => card.context ? navigate(card.context) : null }
                                style={{ textDecoration: "none" }}
                            >
                                <AssetCard
                                    title={card.title}
                                    description={getDescription(card.context!)}
                                    icon={card.icon}
                                    colorClass={card.colorClass}
                                    context={card.context}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </ContentWrapper>

            { assets?.loading && <Loader /> }
        </>
    );
};

